/** The split auth layout's side panel. Downstream apps own its content. */
export function AuthBrandPanel() {
  return (
    <div className="bg-primary text-primary-foreground flex items-center justify-center" />
  )
}
